import Footer from "../footer/Footer";
import { Helmet } from "react-helmet";
import { Trans } from 'react-i18next'
import "./Pages.css";
const YearPlan = () => {
  return (
    <div>
      <div className="projects-year-plan">
        <Helmet>
          <title>
            Esnad e.V | Year Plan| Jahres Plan
          </title>
        </Helmet>
        <Trans i18nKey="Year-Plan-Content" components={{ p: <p/> , pre: <pre/>,h2: <h2/>, h4: <h4/>, ul: <ul/>, li: <li/>, strong: <strong/>, h5: <h5/>}} />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default YearPlan;
